import React from 'react';
import { TextField, btnGhost } from '../ui.jsx';
import NiprGuide from './NiprGuide.jsx';

/**
 * Step 4a — national producer number and the states the agent is licensed in.
 * "Select all" is one click; license copies are uploaded on the next screen.
 */
export default function StatePicker({ ctx }) {
  const { page, patch, catalog } = ctx;
  const states = catalog?.states || [];
  const chosen = new Set(page.licenseStates);
  const toggle = (code) => patch({ licenseStates: chosen.has(code) ? page.licenseStates.filter((c) => c !== code) : [...page.licenseStates, code] });
  const all = states.length > 0 && chosen.size === states.length;

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-lg font-semibold">State Licenses</h3>
        <p className="text-xs text-white/60">Set your national producer number and choose every state you are licensed in. On the next screen you can add a copy of each license or its license number — both are optional.</p>
      </div>

      <NiprGuide defaultOpen={false} />

      <TextField label="National producer number" value={page.nationalProducerNumber} onChange={(v) => patch({ nationalProducerNumber: v.replace(/\D/g, '').slice(0, 20) })} inputMode="numeric" required testId="pp-npn" />

      <div>
        <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
          <span className="text-sm text-white/80">Licensed states <b data-testid="pp-state-count">({chosen.size} selected)</b></span>
          <div className="flex gap-2">
            <button type="button" className={btnGhost} onClick={() => patch({ licenseStates: states.map((s) => s.code) })} disabled={all} data-testid="pp-select-all">Select all</button>
            <button type="button" className={btnGhost} onClick={() => patch({ licenseStates: [] })} disabled={!chosen.size}>Clear</button>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-1.5 sm:grid-cols-3" role="group" aria-label="Licensed states">
          {states.map((s) => (
            <label key={s.code} className={`flex cursor-pointer items-center gap-2 rounded-md border px-2.5 py-1.5 text-xs transition ${chosen.has(s.code) ? 'border-civix-purple bg-civix-purple/20' : 'border-white/10 hover:bg-white/5'}`}>
              <input type="checkbox" checked={chosen.has(s.code)} onChange={() => toggle(s.code)} data-testid={`pp-state-${s.code}`} />
              {s.name}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}
